/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable @typescript-eslint/no-explicit-any */
import { zodResolver } from "@hookform/resolvers/zod";
import { useEffect } from "react";
import { useForm } from "react-hook-form";

import { z } from "zod";

type UseUserformType = {
  formData: any;
  onFormSubmit: (prop: any) => void;
  defaultValue?: any;
  erp_mapping_value?: any;
  order_type?: any;
  cardinality?: any;
};

const formSchema = z.object({
  name: z.string().min(1, {
    message: "Name is required.",
  }),
  erp_mapping: z.string().optional(),
  order_type: z.string().optional(),
  cardinality: z.string().optional(),
  document_types: z.string().optional(),
});

export const useTreeMutationForm = ({
  formData,
  onFormSubmit,
  defaultValue,
  erp_mapping_value,
  order_type,
  cardinality,
}: // open,
UseUserformType) => {
  const schemaKeys = formSchema.keyof().options;

  console.log({ formData });

  const form = useForm<z.infer<typeof formSchema>>({
    resolver: zodResolver(formSchema),
    mode: "onBlur",
    defaultValues: {
      name: defaultValue || "",
      erp_mapping: erp_mapping_value || "",
      order_type: order_type || "",
      cardinality: cardinality || "",
      // type: "",
    },
  });

  useEffect(() => {
    if (formData && Object.keys(formData).length > 0) {
      schemaKeys.forEach((key) => {
        if (formData[key]) {
          const value = formData[key];
          form.setValue(key, value, {
            shouldTouch: true,
            shouldDirty: true,
          });
        }
      });
    }
  }, [formData]);

  function onSubmit(values: z.infer<typeof formSchema>) {
    onFormSubmit(values);
  }

  return { form, onSubmit };
};
